export const headerPaneNames = ['myDay', 'notifications', 'teamsChat'] as const;

export type HeaderPaneName = typeof headerPaneNames[number];
